export default function CartDetails({
  cartItems,

  // Additional props
  // products,
  findProduct,
}) {
  const totalItems = cartItems.reduce((acc, currentValue) => {
    return acc + currentValue.quantity;
  }, 0);

  const totalAmount = cartItems.reduce((acc, currentValue) => {
    // const product = products.find((ele) => ele.id === currentValue.pId);
    const product = findProduct(currentValue.pId);

    // return acc + product.price * currentValue.quantity;
    return product ? acc + product.price * currentValue.quantity : acc;
  }, 0);
  return (
    <>
      <h2>Cart Summary</h2>

      <div className="summary">
        <div className="summary-row">
          <span>Total Items</span>
          <strong>{totalItems}</strong>
        </div>

        <div className="summary-row">
          <span>Total Amount</span>
          <strong>₹{totalAmount}</strong>
        </div>
      </div>
    </>
  );
}
